import { useQuery } from '@tanstack/react-query';
import { products } from '@/utils/api';

export function useProducts(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['products', params],
    queryFn: () => products.getAll(params).then((r) => r.data),
  });
}

export function useProductCategories() {
  return useQuery({
    queryKey: ['products', 'categories'],
    queryFn: () => products.getCategories().then((r) => r.data),
  });
}
